// utils/parseAIAIResponse.js

export function parseAIAIResponse(text) {
    const answerMatch = text.match(/\*\*Answer\*\*([\s\S]*?)(?=\*\*|$)/i);
    const tipMatch = text.match(/\*\*Tip\*\*([\s\S]*?)(?=\*\*|$)/i);
    const actionsMatch = text.match(/\*\*Key Actions\*\*([\s\S]*?)(?=\*\*|$)/i);
    const topicsMatch = text.match(/\*\*Suggested Next Topics\*\*([\s\S]*?)(?=\*\*|$)/i);
  
    const actions = [];
    if (actionsMatch) {
      const actionLines = actionsMatch[1].split('\n').map(line => line.trim()).filter(l => l && !/^[-–•]/.test(l));
      actionLines.forEach(line => {
        if (!/^Action\s+\d+:/.test(line)) {
          actions.push(line); // Only keep lines that are actual content
        }
      });
    }
  
    const topics = topicsMatch ? topicsMatch[1].split('\n').map(t => t.trim()).filter(Boolean) : [];
  
    return {
      answer: answerMatch?.[1]?.trim() || '',
      tip: tipMatch?.[1]?.trim() || '',
      actions,
      topics,
    };
  }
  